<template>
  <keep-alive :max="5">
    <PortalSearchResultComp
      :keyword="keyword"
      :creatorKbn="creatorKbn"
      :tags="tags"
      :liked="liked"
      :opend="opend"
      :ocItem="ocItem"
      :ocWorld="ocWorld"
      :type="type"
      :s="s"
      :cId="cId"
      :worldId="worldId"
      :creatorId="creatorId"
      :shouhinKbn="shouhinKbn"
      :key="$route.fullPath"
    />
  </keep-alive>
</template>

<script>
import PortalSearchResultComp from "@/views/portalSearch/portalSearchResultComp";
export default {
  name: "portalSearchResult",
  components: {
    PortalSearchResultComp,
  },

  props: {
    keyword: {
      mode: String,
      required: false,
      default: "",
    },
    creatorKbn: {
      mode: Number,
      required: false,
      default: 0,
    },
    tags: {
      mode: Array,
      required: false,
    },
    liked: {
      mode: Boolean,
      default: false,
    },
    opend: {
      mode: Boolean,
      default: false,
    },
    ocItem: {
      mode: Array,
      required: false,
    },
    ocWorld: {
      mode: Array,
      required: false,
    },
    type: {
      mode: String,
      required: false,
      default: "all",
    },
    s: {
      mode: String,
      required: false,
    },
    cId: {
      mode: String,
      default: false,
    },
    worldId: {
      mode: String,
      default: false,
    },
    creatorId: {
      mode: Number,
      required: false,
    },
    shouhinKbn: {
      mode: String,
      required: false,
    },
  },
  inject: ["getLikedInfo", "searchReload", "reload"],
  data() {
    return {};
  },

  computed: {},

  watch: {
    // $props: {
    //   handler: async function (val, oldval) {
    //     this.reset();
    //     // console.log(JSON.stringify(val));
    //     // console.log(this.p);
    //     // if (JSON.stringify(val) != this.p) {
    //     //   console.log("reset");
    //     // } else {
    //     //   console.log("keep");
    //     // }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";
</style>
